import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import Login from './pages/Login/Login';
import Impressum from './pages/legal/Impressum';
import Datenschutz from './pages/legal/Datenschutz';

// Super Admin
import SuperAdminDashboard from './pages/superadmin/Dashboard/SuperAdminDashboard';
import CustomerList from './pages/superadmin/Customers/CustomerList';
import CustomerDetail from './pages/superadmin/Customers/CustomerDetail';
import TrainingList from './pages/superadmin/Trainings/TrainingList';
import TrainingForm from './pages/superadmin/Trainings/TrainingForm';
import TrainingDetail from './pages/superadmin/Trainings/TrainingDetail';
import Billing from './pages/superadmin/Billing/Billing';

// Customer Admin
import CustomerAdminDashboard from './pages/customeradmin/Dashboard/CustomerAdminDashboard';
import UserList from './pages/customeradmin/Users/UserList';
import CustomerTrainings from './pages/customeradmin/Trainings/CustomerTrainings';
import Reports from './pages/customeradmin/Reports/Reports';
import CustomerBilling from './pages/customeradmin/Billing/CustomerBilling';

// Employee
import MyTrainings from './pages/employee/MyTrainings/MyTrainings';
import TrainingView from './pages/employee/TrainingView/TrainingView';
import Quiz from './pages/employee/Quiz/Quiz';

function RoleRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'super_admin') return <Navigate to="/admin/dashboard" replace />;
  if (user.role === 'customer_admin') return <Navigate to="/customer/dashboard" replace />;
  return <Navigate to="/my-trainings" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RoleRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />

          {/* Super Admin */}
          <Route path="/admin/dashboard" element={<ProtectedRoute roles={['super_admin']}><SuperAdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/customers" element={<ProtectedRoute roles={['super_admin']}><CustomerList /></ProtectedRoute>} />
          <Route path="/admin/customers/:id" element={<ProtectedRoute roles={['super_admin']}><CustomerDetail /></ProtectedRoute>} />
          <Route path="/admin/trainings" element={<ProtectedRoute roles={['super_admin']}><TrainingList /></ProtectedRoute>} />
          <Route path="/admin/trainings/new" element={<ProtectedRoute roles={['super_admin']}><TrainingForm /></ProtectedRoute>} />
          <Route path="/admin/trainings/:id" element={<ProtectedRoute roles={['super_admin']}><TrainingDetail /></ProtectedRoute>} />
          <Route path="/admin/trainings/:id/edit" element={<ProtectedRoute roles={['super_admin']}><TrainingForm /></ProtectedRoute>} />
          <Route path="/admin/billing" element={<ProtectedRoute roles={['super_admin']}><Billing /></ProtectedRoute>} />

          {/* Customer Admin */}
          <Route path="/customer/dashboard" element={<ProtectedRoute roles={['customer_admin']}><CustomerAdminDashboard /></ProtectedRoute>} />
          <Route path="/customer/users" element={<ProtectedRoute roles={['customer_admin']}><UserList /></ProtectedRoute>} />
          <Route path="/customer/trainings" element={<ProtectedRoute roles={['customer_admin']}><CustomerTrainings /></ProtectedRoute>} />
          <Route path="/customer/reports" element={<ProtectedRoute roles={['customer_admin']}><Reports /></ProtectedRoute>} />
          <Route path="/customer/billing" element={<ProtectedRoute roles={['customer_admin']}><CustomerBilling /></ProtectedRoute>} />

          {/* Employee + Customer Admin */}
          <Route path="/my-trainings" element={<ProtectedRoute roles={['employee', 'customer_admin']}><MyTrainings /></ProtectedRoute>} />
          <Route path="/my-trainings/:id" element={<ProtectedRoute roles={['employee', 'customer_admin']}><TrainingView /></ProtectedRoute>} />
          <Route path="/my-trainings/:id/quiz" element={<ProtectedRoute roles={['employee', 'customer_admin']}><Quiz /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
